"use client";

import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import {Field} from "@/components/form";

type AddRemoveOfferModalProps = {
    isOffer: boolean;
    discount: string;
    setDiscount: React.Dispatch<React.SetStateAction<string>>;
    onSubmit: () => void;
};

export default function AddRemoveOfferModal({
                                                isOffer,
                                                discount,
                                                setDiscount,
                                                onSubmit,
                                            }: AddRemoveOfferModalProps) {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSubmit();
        }
    };

    return (
        <Box onKeyDown={handleKeyDown}>
            {!isOffer && (
                <Stack>
                    <Field.Text
                        fullWidth
                        label="درصد تخفیف (%)"
                        placeholder="درصد تخفیف را وارد کنید..."
                        value={discount}
                        onChange={(e) => setDiscount(e.target.value)}
                    />
                </Stack>
            )}

            {isOffer && (
                <Typography mb={2} fontSize={15}>
                    آیا از حذف پیشنهاد ویژه این محصول اطمینان دارید؟
                </Typography>
            )}
        </Box>
    );
}